
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-a96312a2!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./channelsharing.vue")
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-a96312a2&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./channelsharing.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./channelsharing.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-a96312a2!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./channelsharing.vue"),
  /* scopeId */
  "data-v-a96312a2",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/financialManagement/channelsharing.vue
// module id = 1506
// module chunks = 3